<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        {{ groupe.nom_groupe }} - {{ projet.ll_programme }} -
        {{ groupe.nom_responsable }}

        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text>
        <div
          class="mb-6 pa-4"
          v-for="(campagne, index) in filtreCampagne(projet.id, annee_actuelle)"
          :key="index"
        >
          <div class="pa-2" align="center" justify="center">
            {{ campagne.ll_campagne }}
          </div>

          <template>
            <div>
              <listeActivites
                :projet="projet"
                :campagne="campagne"
                :month="$route.query.month"
                :groupe="groupe"
                :key="key2"
                @resetComopent="resetComponentKey()"
                @insertOneParcoursEffectif="insertOneParcoursEffectif"
              />
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      detailsAnimateur: {},
      generated: [],
      openedPanel: null,
      key1: this.$uuid.v4(),
      key2: this.$uuid.v4(),
      key3: this.$uuid.v4(),
    };
  },
  created() {
    this.getDetailsAnimateur();
    this.loadSuperviseurParcoursEffectif();
  },
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    detailCampagne: require("@/components/groupes/detailCampagne.vue").default,
    dialogNewMembre: require("@/components/groupes/dialogNewMembre.vue")
      .default,
    dialogNewCampagne: require("@/components/groupes/dialogNewCampagne.vue")
      .default,
    dialogNewCycleGec: require("@/components/groupes/dialogNewCycleGec.vue")
      .default,
    dialogNewFormation: require("@/components/groupes/dialogNewFormation.vue")
      .default,
    dialogNewIntrant: require("@/components/groupes/dialogNewIntrant.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    activites: require("@/components/groupes/activites.vue").default,
    listeActivites: require("@/components/groupes/listeActivites.vue").default,
  },
  computed: {
    ...mapState({
      groupe: (state) => state.Groupes.itemById,
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
      actual_month: (state) => state.Utils.actual_month,
      previous_month: (state) => state.Utils.previous_month,
      previous_month2: (state) => state.Utils.previous_month2,
      annee_actuelle: (state) => state.Utils.annee_actuelle,
      Activites(state) {
        return _.filter(state.Activites.Activites, {
          programmes_id_programme: this.projet.id,
        });
      },
      projet: function (state) {
        return _.filter(state.Projets.projets, {
          id: this.$route.query.idProjet,
        })[0];
      },
    }),
  },
  methods: {
    getDetailsAnimateur() {
      let self = this;
      let idAnimateur = self.groupe.responsable;

      var docRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(idAnimateur);
      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.detailsAnimateur = doc.data();
            var item = self.detailsAnimateur;
            item.id = doc.data().uid;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    insertOneParcoursEffectif(parcoursEffectif) {
      this.addOneItem(parcoursEffectif);
    },
    filtreCampagne(idProjet, annee_actuelle) {
      var filtered = _.filter(this.campagneActive, {
        programme_id_programme: idProjet,
        annee: annee_actuelle,
      });
      return _.sortBy(filtered, [
        function (o) {
          return o.ll_campagne;
        },
      ]);
    },

    resetComponentKey() {
      this.key1 = this.$uuid.v4() + "1";
      this.key2 = this.$uuid.v4() + "2";
      this.key3 = this.$uuid.v4() + "3";
    },

    loadSuperviseurParcoursEffectif() {
      var objet = { userId: this.groupe.responsable, project: this.projet };
      this.GetEtapeEffectiveDeAnimateur(objet);
      this.GetFichesOfAnimateur(objet);
      this.GetSuperviseurParcoursEffectif(objet);
    },

    ...mapActions({
      GetActivites: "Activites/GetAll",
      addOneItem: "ParcoursEffectif/addOneItem",
      GetSuperviseurParcoursEffectif:
        "ParcoursEffectif/GetSuperviseurParcoursEffectif",
      GetEtapeEffectiveDeAnimateur:
        "EtapeEffective/GetEtapeEffectiveDeAnimateur",
      GetFichesOfAnimateur: "Fiches/get_fiche_of_animateur",
    }),
  },
};
</script>

<style lang="scss" scoped>
.blue-theme {
  background-color: #eee !important;
}
.row-pointer:hover {
  cursor: pointer;
}
</style>
